import type { BadgeProps, BoxProps, TextProps } from '@shopify/polaris';
import type { IPlanToolTipKey } from '../../types';

import { Badge, Box, Icon, InlineStack, Text } from '@shopify/polaris';
import { QuestionCircleIcon } from '@shopify/polaris-icons';
import { GTooltipCard } from '~/presentation/ui';
import { PLAN_TOOLTIP } from '../../constants';

interface FeatureTitleProps {
  title: string;
  tooltipKey?: IPlanToolTipKey;
  variant?: TextProps['variant'];
  fontWeight?: TextProps['fontWeight'];
  boxProps?: BoxProps;
  badgeProps?: BadgeProps;
}

export const FeatureTitle: React.FC<FeatureTitleProps> = ({
  title,
  tooltipKey,
  variant = 'bodyMd',
  fontWeight = 'medium',
  boxProps,
  badgeProps,
}) => {
  return (
    <Box {...boxProps}>
      <InlineStack gap="200">
        <Text as="p" variant={variant} fontWeight={fontWeight}>
          {title}
        </Text>

        {tooltipKey && (
          <GTooltipCard
            activatorProps={{ borderBlockEndWidth: '0' }}
            tooltip={{
              ...PLAN_TOOLTIP[tooltipKey],
              width: 'large',
            }}
          >
            <Icon source={QuestionCircleIcon} tone="subdued" />
          </GTooltipCard>
        )}

        {badgeProps && <Badge {...badgeProps} />}
      </InlineStack>
    </Box>
  );
};
